import React from 'react';
import '../../App.scss';
import '../../css/modals.scss';
import { useEffect, useState, useContext } from 'react';
import BaseModal from './BaseModal';
import BaseForm from '../BaseForm';
import SubmitButton from '../SubmitButton';
import { useTranslation } from 'react-i18next';
import { Row, Col, Button } from 'react-bootstrap';
import { getPaymentExportNewFields } from '../../helpers/exportFields';
import { serverPost } from '../../helpers/server';
import { downloadBlob, BaseContext } from '../../helpers/common';
import moment from 'moment';
const _ = require("lodash");

function PaymentsPDFExportModal(props) {
    const { getApiUrl } = useContext(BaseContext);
    const { t } = useTranslation(['common']);
    const [currentTab, setCurrentTab] = useState("report");
    const [items, setItems] = useState([]);
    const [criteria, setCriteria] = useState(null);
    const [fields, setFields] = useState([]);
    const [selectedFields, setSelectedFields] = useState([]);
    const [allFields, setAllFields] = useState([]);

    const [formRef, setFormRef] = useState(React.createRef());
    const { settings } = useContext(BaseContext);

    useEffect(() => {
        setCurrentTab("report");
        setFields(getPaymentExportNewFields(settings));
        let _allFields = [];
        _.each(fields, (fs, j) => {
            _.each(fs.fields, (f, i) => {
                _allFields.push(f);
            })
        })
        setAllFields(_allFields);
        let preselectedFields = []
        setSelectedFields(preselectedFields);
    }, [props.show]);

    useEffect(() => {
        setItems(props.items);
    }, [props.items]);

    useEffect(() => {
        setCriteria(props.criteria);
    }, [props.criteria]);

    const updateChecked = (event) => {
            const newSelectedFields = [...selectedFields];
            if (event.target.checked) {
                newSelectedFields.push(event.target.value);
            } else {
                let index = newSelectedFields.indexOf(event.target.value);
                if (index > -1) {
                    newSelectedFields.splice(index, 1);
                }
            }
            setSelectedFields(newSelectedFields);
    }

    const onExport = (data) => {
        let filteredFields = [...selectedFields];
        const originalFieldOrder = _.map(allFields, (f) => f.value);
        filteredFields = _.sortBy(filteredFields, (f) => _.indexOf(originalFieldOrder, f));
        console.log(filteredFields);

        const exportData = {
            format: "pdf",
            fields: filteredFields,
            options: {
                orientation: data.orientation,
                title: data.title,
                companyName: data.companyName,
                notes: data.reportNotes,
            },
        }
        if (props.useCriteria) {
            exportData['criteria'] = criteria;
        } else {
            exportData['forExport'] = {
                ids: _.map(items, (i) => i.id)
            };
        }
        const filename = `Payment-reports-${moment().format("MMM-DD-YYYY")}.pdf`;
        serverPost(getApiUrl(settings.useNewPaymentsTable ? '/payments/v2/export' : '/payments/export'), exportData, { noJson: true }).then((res) => {
            downloadBlob(res, filename);
        })
        props.onClose();
    }

    const pdfViewOptions = [
        { value: "P", label: "Portrait" },
        { value: "L", label: "Landscape" },
    ]

    const tabItems = [
        { value: "report", label: "Report Items", icon: "fa-list", active: currentTab === "report", onClick: () => setCurrentTab("report") },
        { value: "details", label: "PDF Details", icon: "fa-info-circle", active: currentTab === "details", onClick: () => setCurrentTab("details") }
    ];

    return (
        <BaseModal {...props} size="lg">
            <BaseModal.Header>
                <BaseModal.Title>Payment Report</BaseModal.Title>
            </BaseModal.Header>
            <BaseForm ref={formRef} onSubmit={onExport}>
                <div className="content-box">
                    <div className="content-body">
                        <div>
                            <p class="h6">Including a high number of fields in the PDF report can degrade readability and formatting. If you need many or all fields, consider using the CSV export option instead of PDF.</p>
                            {
                                _.map(fields, (fs, j) =>
                                    <React.Fragment key={j}>
                                        {
                                            fs.title &&
                                                <h6><b>{fs.title}</b></h6>
                                        }
                                        <Row>
                                        {
                                            _.map(fs.fields, (f, i) =>
                                                <Col md="3" key={i}>
                                                    <div className="checkbox check-success tall"><input type="checkbox" name="fields[]" id={f.id} value={f.value} checked={selectedFields.includes(f.value)} onChange={ (event) => updateChecked(event) }/><label htmlFor={f.id}>{f.label}</label></div>
                                                </Col>
                                            )
                                        }
                                        </Row>
                                    </React.Fragment>
                                )
                            }
                            <br/>
                            <Row>
                                <BaseForm.Input colSpan="4" type="select" name="orientation" label="PDF View" options={pdfViewOptions} showSearch={false} />
                                <BaseForm.Input colSpan="4" type="text" name="title" label="Report Title" placeholder="Payment Report" />
                                <BaseForm.Input colSpan="4" type="text" name="companyName" label="Company Name" />
                                <BaseForm.Input colSpan="12" type="editor" name="reportNotes" className="notes-input"/>
                            </Row>
                        </div>
                    </div>
                </div>
                <BaseModal.Footer>
                    <Row>
                        <Col md="12" className="text-end">
                            <Button variant="link" onClick={() => props.onClose()}>Close</Button>
                            <SubmitButton><i className="fa fa-print"/> Export PDF</SubmitButton>
                        </Col>
                    </Row>
                </BaseModal.Footer>
            </BaseForm>
        </BaseModal>
    );

}

export default PaymentsPDFExportModal;
